import { useState } from "react";

import { ResponsiveInfoTooltipIcon } from "../../ResponsiveInfoTooltip";
import { TooltipWrapper } from "../../Tooltip";
import { MobileStatusModal } from "../LeadsTable/MobileStatusModal";

type LeadInfoInfoDashboardTooltipProps = {
  title: string;
  tooltipText: string;
  isMobile?: boolean;
  onHover?: (isMobile: boolean) => void;
};

const MobileTooltip = ({
  title,
  tooltipText,
  onHover,
}: Pick<
  LeadInfoInfoDashboardTooltipProps,
  "title" | "tooltipText" | "onHover"
>) => {
  const [mobileModalLeadVisible, setMobileModalLeadVisible] = useState(false);

  return (
    <div
      className="flex flex-row items-center justify-start gap-2 md:justify-end"
      data-testid="lead-info-card-tooltip"
    >
      <MobileStatusModal
        isVisible={mobileModalLeadVisible}
        close={() => setMobileModalLeadVisible(false)}
        status={title}
        statusDescription={tooltipText}
      />
      <span
        data-testid="lead-info-card-tooltip-icon"
        className="cursor-pointer"
        onClick={() => {
          onHover?.(true);
          setMobileModalLeadVisible(true);
        }}
      >
        <ResponsiveInfoTooltipIcon iconSize={24} iconType="default" />
      </span>
    </div>
  );
};

const DesktopTooltip = ({
  tooltipText,
  onHover,
}: Pick<LeadInfoInfoDashboardTooltipProps, "tooltipText" | "onHover">) => (
  <TooltipWrapper
    data-testid="lead-info-card-tooltip"
    color="blue"
    tooltipPlacement="top"
    text={tooltipText}
    tooltipTextAlign="text-center"
    trackTooltipHover={() => {
      onHover?.(false);
    }}
  >
    <ResponsiveInfoTooltipIcon iconSize={24} iconType="default" />
  </TooltipWrapper>
);

export const LeadInfoInfoDashboardTooltip = ({
  title,
  tooltipText,
  isMobile,
  onHover,
}: LeadInfoInfoDashboardTooltipProps) => {
  if (isMobile) {
    return (
      <MobileTooltip
        title={title}
        tooltipText={tooltipText}
        onHover={onHover}
      />
    );
  }

  return <DesktopTooltip tooltipText={tooltipText} onHover={onHover} />;
};
